// Stripe reports outstanding onboarding requirements as API field paths
// ("individual.ssn_last_4", "individual.dob.day", "company.tax_id", ...). They are
// identifiers, not sentences: shown raw they read as "Ssn last 4" / "Day" / "Month"
// / "Year", which tells a venue nothing. This turns a list of them into a short,
// deduplicated list of things a person can actually go and provide.
//
// Order matters - the first matching prefix wins, so the specific entries sit above
// the broad "individual." / "company." catch-alls.
const LABELS = [
  ["individual.ssn_last_4", "Last 4 digits of your Social Security number"],
  ["individual.id_number", "Your full Social Security number"],
  ["individual.dob", "Your date of birth"],
  ["individual.address", "Your home address"],
  ["individual.phone", "Your phone number"],
  ["individual.email", "Your email address"],
  ["individual.first_name", "Your legal name"],
  ["individual.last_name", "Your legal name"],
  ["individual.verification.document", "A photo of your government-issued ID"],
  ["individual.verification.additional_document", "A proof-of-address document"],
  ["individual.", "Your personal details"],
  ["company.tax_id", "Your EIN / business tax ID"],
  ["company.name", "Your legal business name"],
  ["company.address", "Your business address"],
  ["company.phone", "Your business phone number"],
  ["company.verification.document", "A business verification document"],
  ["company.", "Your business details"],
  ["representative.", "Details for your account representative"],
  ["owners.", "Details for the business owners"],
  ["directors.", "Details for the business directors"],
  ["executives.", "Details for the business executives"],
  ["person_", "Details for a person on the account"],
  ["external_account", "A bank account for payouts"],
  ["tos_acceptance", "Acceptance of Stripe's terms of service"],
  ["business_profile.url", "Your business website"],
  ["business_profile.mcc", "Your business category"],
  ["business_profile.product_description", "A description of what you sell"],
  ["business_profile.", "Your business profile"],
  ["settings.payments.statement_descriptor", "A statement descriptor for card statements"],
];

const fallbackLabel = (key) => {
  const tail = String(key).split(".").pop() || String(key);
  return tail.charAt(0).toUpperCase() + tail.slice(1).replace(/_/g, " ");
};

export const stripeRequirementLabel = (key) => {
  const k = String(key || "");
  const hit = LABELS.find(([prefix]) => k.startsWith(prefix));
  return hit ? hit[1] : fallbackLabel(k);
};

// Several keys collapse to one label (dob.day/month/year -> "date of birth"), so the
// output is deduplicated and keeps Stripe's order of first appearance.
export const describeStripeRequirements = (keys) => {
  const seen = new Set();
  return (Array.isArray(keys) ? keys : []).reduce((out, key) => {
    const label = stripeRequirementLabel(key);
    if (!seen.has(label)) {
      seen.add(label);
      out.push(label);
    }
    return out;
  }, []);
};
